import React, { useState } from 'react'
import AuthService from '../../services/AuthService'
import FooterPages from '../Footer/FooterPages'
//import note from "/Assets/Images/note.png"

import { useNavigate } from 'react-router'
import { useLocation } from 'react-router'
import UserService from '../../services/UserService'
import Navbar3 from '../Navbars/Navbar3'

function Dashboard() {
    const commonFeatures = [
                            {
                                title: "Model Performance",
                                subtitle: "Diagnostics",
                                text: "Model Performance compares actual outcomes with predicted results to assess accuracy and reliability of the model which provides insights for refining and improving model predictions over time.",
                                link: "/TMLModelPerformance",
                            },
                            {
                                title: "Market Analysis",
                                subtitle: "Diagnostics",
                                text: "Market Analysis dissects expenditure trends among single brand with multiple tactics in a specific source of expenditure over a defined time frame, providing valuable insights for analytics.",
                                link: "",
                            },
                            // {
                            //     title: "Brand Analysis",
                            //     subtitle: "Diagnostics",
                            //     text: "Brand Analysis dissects expenditure trends among single brand with multiple tactics in a specific source of expenditure over a defined time frame, providing valuable insights for analytics.",
                            //     link: "",
                            // },
                            {
                                title: "LSM Planner",
                                subtitle: "Simulation",
                                text: "A Lead Source Management Planner is a strategic tool or framework used by businesses to track, manage, and optimize the sources from which potential customers (leads) originate. Its primary purpose is to help sales and marketing teams understand which lead sources (e.g., social media, referrals, ads, events, websites) are generating the most valuable leads and how to allocate resources effectively.",
                                link: "/TMLSimulator",
                            },
                            // {
                            //     title: "Optimized Spends",
                            //     subtitle: "Optimization",
                            //     text: "Optimized Spends analyzes expenditure data and user-defined budgets to recommend optimal spending strategies helping in allocation of resources, ensuring maximum return on investment.",
                            //     link: "TMLOptimizer",
                            // },
                            {
                                title: "Saved Scenarios",
                                subtitle: "Simulation",
                                text: "Saved Scenarios analyzes expenditure data and user-defined budgets to recommend optimal spending strategies helping in allocation of resources, ensuring maximum return on investment.",
                                link: "",
                            },
                            {
                                title: "Saved Reports",
                                subtitle: "User Saved",
                                text: "Saved Reports lets User to access securely their saved reports for future reference and continued analysis.",
                                link: "/savedreports",
                            },
                        ]

    return (
        <>
            <Navbar3 />
            <div className="container-fluid aftrlogincontainer3 ">
                <div className="container mycontainer py-4">
                    <div className="row gy-4">

                        {/* ADMIN ONLY */}
                        {/*UserService.hasRole(["adminrole"]) && (
                            <div className="col-lg-6 col-md-12">
                                <div className="afterlogcon3box1 p-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h3 className="mb-0">Refresh Model</h3>
                                        <span className="badge p-2" style={{
                                            backgroundColor: '#19332D',
                                            color: '#fff'
                                        }}>Admin Control</span>
                                    </div>
                                    <p>
                                        Refresh Model feature enables the administrator to upload a new Excel file
                                        containing updated data and refresh the system's model accordingly.
                                    </p>
                                    <div className="alborderbottom1 my-2"></div>
                                    <div className="trybtn">
                                        <a href="/refreshmodel" aria-label="Refresh Model">
                                            Go <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )*/}

                        {/* COMMON FEATURES */}
                        {commonFeatures.map((feature, index) => (
                            <div key={index} className="col-lg-6 col-md-12">
                                <div className="afterlogcon3box1 p-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h3 className="mb-0">{feature.title}</h3>
                                        <span className="badge p-2" style={{
                                            backgroundColor: '#19332D',
                                            color: '#fff'
                                        }}>{feature.subtitle}</span>
                                    </div>
                                    <p>{feature.text}</p>
                                    <div className="alborderbottom1 my-2"></div>
                                    <div className="trybtn">
                                        <a href={feature.link} aria-label={feature.title}>
                                            Go <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <FooterPages />
        </>

    )
}

export default Dashboard